import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { StatsService } from '../../stats.service';
import { TranslateService } from '@ngx-translate/core';
import { tap, first } from 'rxjs/operators';
@Component({
  selector: '[app-panel-chart]',
  template: `
      <td class="container-fluid">
        <h5>{{ name | translate }}</h5>
      </td>
      <td>
        {{content}}
      </td>
  `
})
export class PanelComponent implements OnInit {
  @Input() url: Function;
  @Input() name: string;
  @Input() sessionId: any;
  @Input() format: Function;
  @Input() showCircle: boolean;
  content: any;
  constructor(private statsService: StatsService, private translate: TranslateService) {}

  ngOnInit() {
    const source$ = this.statsService.call(this.url(this.sessionId));
    const format$ = tap((content: any) => (this.content = this.format(content.value)));
    source$.pipe(first(), format$).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/panel/panel.component.ts